import React from 'react';
import TechActionContainer from '../../containers/techAction/TechActionContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const TechActionPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="기술활동관리/기술활동등록" icon="partner" />
      <TechActionContainer />
    </>
  );
};

export default TechActionPage;
